module.exports = __webpack_public_path__ + "img/star_card.31633f17.png";